import { Helmet } from 'react-helmet-async';
import PercursoSummary from '@/components/PercursoSummary';
import RecommendationsCard from '@/components/RecommendationsCard';
import { hasSuggestions } from '@/lib/recommendations';
import PercursoTrail from '@/components/PercursoTrail';
import { useMyPercurso } from '@/hooks/usePercurso';
import { useMyRecommendations } from '@/hooks/useRecommendations';
import { useAuthStore } from '@/stores/auth';

export default function PercursoPage() {
  const { user } = useAuthStore();
  const participantId = typeof user?.id === 'number' ? user.id : undefined;
  const percursoQuery = useMyPercurso(participantId);
  const percurso = percursoQuery.data;
  // Shown only when the server has suggestions switched on and has enough
  // history to make them; otherwise the page is as it was.
  const recommendations = useMyRecommendations(participantId).data;

  return (
    <>
      <Helmet>
        <title>Percurso | AICD</title>
      </Helmet>
      <div className="space-y-6">
        <header>
          <h1 className="text-2xl font-black text-foreground">O meu percurso</h1>
          <p className="mt-1 subtitle text-sm text-muted-foreground">
            Tudo o que fez nos Centros, dia a dia, até hoje.
          </p>
        </header>

        {percursoQuery.isLoading && <PercursoSkeleton />}

        {percursoQuery.isError && !percursoQuery.isLoading && (
          <div
            role="alert"
            className="rounded-2xl border border-busy/50 bg-busy-soft p-4 text-sm text-busy"
          >
            Não foi possível carregar o percurso. Tente novamente mais tarde.
          </div>
        )}

        {percurso && (
          <>
            {percurso.stops.length > 0 && <PercursoSummary totals={percurso.totals} />}
            {hasSuggestions(recommendations) && <RecommendationsCard data={recommendations} />}
            <PercursoTrail stops={percurso.stops ?? []} />
          </>
        )}
      </div>
    </>
  );
}

function PercursoSkeleton() {
  return (
    <ul className="space-y-4" aria-hidden="true">
      {[0, 1, 2].map((i) => (
        <li key={i} className="flex gap-4">
          <div className="h-7 w-7 flex-shrink-0 animate-pulse rounded-full bg-input-soft" style={{ marginLeft: 20 + (i % 2) * 20 }} />
          <div className="flex-1 space-y-2 rounded-2xl border border-border bg-card p-3">
            <div className="h-3 w-2/3 animate-pulse rounded bg-input-soft" />
            <div className="h-2 w-1/3 animate-pulse rounded bg-input-soft" />
          </div>
        </li>
      ))}
    </ul>
  );
}
